/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetMenuAvailability200ResponseProductsInner
 */
export interface GetMenuAvailability200ResponseProductsInner {
    /**
     * 
     * @type {string}
     * @memberof GetMenuAvailability200ResponseProductsInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetMenuAvailability200ResponseProductsInner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetMenuAvailability200ResponseProductsInner
     */
    shortName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetMenuAvailability200ResponseProductsInner
     */
    imageId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetMenuAvailability200ResponseProductsInner
     */
    color?: string;
    /**
     * 
     * @type {number}
     * @memberof GetMenuAvailability200ResponseProductsInner
     */
    stock?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetMenuAvailability200ResponseProductsInner
     */
    enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetMenuAvailability200ResponseProductsInner
     */
    refillPolicy?: GetMenuAvailability200ResponseProductsInnerRefillPolicyEnum;
    /**
     * 
     * @type {number}
     * @memberof GetMenuAvailability200ResponseProductsInner
     */
    refillValue?: number;
    /**
     * 
     * @type {number}
     * @memberof GetMenuAvailability200ResponseProductsInner
     */
    lowStockThreshold?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetMenuAvailability200ResponseProductsInner
     */
    hideOnLowStock?: boolean;
}


/**
 * @export
 */
export const GetMenuAvailability200ResponseProductsInnerRefillPolicyEnum = {
    UntilSoldOut: 'until-sold-out',
    RefillShift: 'refill-shift',
    RefillDaily: 'refill-daily',
    JustToday: 'just-today'
} as const;
export type GetMenuAvailability200ResponseProductsInnerRefillPolicyEnum = typeof GetMenuAvailability200ResponseProductsInnerRefillPolicyEnum[keyof typeof GetMenuAvailability200ResponseProductsInnerRefillPolicyEnum];


/**
 * Check if a given object implements the GetMenuAvailability200ResponseProductsInner interface.
 */
export function instanceOfGetMenuAvailability200ResponseProductsInner(value: object): value is GetMenuAvailability200ResponseProductsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function GetMenuAvailability200ResponseProductsInnerFromJSON(json: any): GetMenuAvailability200ResponseProductsInner {
    return GetMenuAvailability200ResponseProductsInnerFromJSONTyped(json, false);
}

export function GetMenuAvailability200ResponseProductsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMenuAvailability200ResponseProductsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'shortName': json['shortName'] == null ? undefined : json['shortName'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'color': json['color'] == null ? undefined : json['color'],
        'stock': json['stock'] == null ? undefined : json['stock'],
        'enabled': json['enabled'],
        'refillPolicy': json['refillPolicy'] == null ? undefined : json['refillPolicy'],
        'refillValue': json['refillValue'] == null ? undefined : json['refillValue'],
        'lowStockThreshold': json['lowStockThreshold'] == null ? undefined : json['lowStockThreshold'],
        'hideOnLowStock': json['hideOnLowStock'] == null ? undefined : json['hideOnLowStock'],
    };
}

export function GetMenuAvailability200ResponseProductsInnerToJSON(json: any): GetMenuAvailability200ResponseProductsInner {
    return GetMenuAvailability200ResponseProductsInnerToJSONTyped(json, false);
}

export function GetMenuAvailability200ResponseProductsInnerToJSONTyped(value?: GetMenuAvailability200ResponseProductsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'shortName': value['shortName'],
        'imageId': value['imageId'],
        'color': value['color'],
        'stock': value['stock'],
        'enabled': value['enabled'],
        'refillPolicy': value['refillPolicy'],
        'refillValue': value['refillValue'],
        'lowStockThreshold': value['lowStockThreshold'],
        'hideOnLowStock': value['hideOnLowStock'],
    };
}

